const funcs = (defaultR) => ({
  int: (str) => {
    const finds = str.toString().match(/^\d+$/g)
    return finds instanceof Array ? finds.join('') : defaultR
  },
  currency: (str) => {
    const finds = str.toString().match(/^\d*\.?\d{0,2}$/g)
    return finds instanceof Array ? finds[0] || finds[1] : defaultR
  },
  num: (str) => {
    const finds = str.toString().match(/^\d*\.?\d*$/g)
    return finds instanceof Array ? finds[0] || finds[1] : defaultR
  },
  matchReg: (regex) => (str) => {
    const finds = str.toString().match(regex)
    return finds instanceof Array ? finds[0] || finds[1] : defaultR
  },
  uppercase: (str) => str.toUpperCase(),
  lowercase: (str) => str.toLowerCase(),
  Number: (str) => Number(str),
  blankNull: (str) => (str === '' ? null : str),
  blankNullNum: (str) => (str === '' ? null : Number(str)),
})

function StripString(defaults = undefined) {
  const params = []
  return {
    get int() {
      params.push('int')
      return this
    },
    get currency() {
      params.push('currency')
      return this
    },
    get num() {
      params.push('num')
      return this
    },
    get Number() {
      params.push('Number')
      return this
    },
    get blankNull() {
      params.push('blankNull')
      return this
    },
    get blankNullNum() {
      params.push('blankNullNum')
      return this
    },
    get lowercase() {
      params.push('lowercase')
      return this
    },
    get uppercase() {
      params.push('uppercase')
      return this
    },
    matchReg(value) {
      params.push({ key: 'matchReg', value })
      return this
    },
    strip(str) {
      if (str === null || str === undefined) return str
      if (!str) return defaults
      return params.reduce(
        (prev, curr) =>
          typeof curr === 'string'
            ? funcs(defaults)[curr](prev)
            : funcs(defaults)[curr.key](curr.value)(prev),
        str
      )
    },
  }
}

export default StripString
